import * as Yup from "yup";
import { InterventionType, Maybe, } from "../../generated/graphql";

const getSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required().default(""),
        abbreviation: Yup.string().required().default(""),
    })
}

export const getInitialValues = (schema: Yup.ObjectSchema<any>) => {
    return schema.cast({});
}

const interventionTypeFormInit = (record?: Maybe<InterventionType>) => {
    const schema = getSchema()
    const initial = record ? record : getInitialValues(schema)
    return { schema, initial }
}

export default interventionTypeFormInit
